import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPendingVendorsRequest, approveVendorRequest } from 'store/actions';
import Breadcrumb from 'components/Common/Breadcrumb2';
import PendingVendorTable from './PendingVendorTable';
import { getEncryptedLocal } from 'pages/Utility/cookieUtils';
import { useNavigate } from 'react-router-dom';

const PendingVendorList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const pendingVendors = useSelector((state) => state.User.pendingVendors);
    const loading = useSelector((state) => state.User.loading);
    const error = useSelector((state) => state.User.error);
    const permissions = getEncryptedLocal("permissions");

    const hasApprovePermission = permissions?.some(
        (item) => item?.permission_name === 'User Edit' // Reusing User Edit for approval
    );

    useEffect(() => {
        dispatch(fetchPendingVendorsRequest());
    }, [dispatch]);

    const handleApprove = (id) => {
        dispatch(approveVendorRequest(id));
    };

    return (
        <React.Fragment>
            <div className="page-content container-fluid mt-4">
                <div className="mx-3">
                    <Breadcrumb
                        title="Pending Vendors"
                        breadcrumbItems={[
                            { title: 'Dashboard', link: '/dashboard' },
                            { title: 'Pending Vendors', link: '#' }
                        ]}
                    />
                </div>

                <PendingVendorTable 
                    vendors={pendingVendors?.data || []} 
                    loading={loading} 
                    error={error} 
                    onApprove={handleApprove}
                    hasApprovePermission={hasApprovePermission}
                />
            </div>
        </React.Fragment>
    );
};

export default PendingVendorList;
